import { useTerminalsStateRE } from "@/States/Terminals";
import { Page } from "@/components/Page";
import { TenantWasteTypesCard } from "@/components/pageCards/tenantWasteTypesCard";

import { FC } from "react";

export const TenantWasteTypes: FC<{}> = () => {
  const { currentTerminal } = useTerminalsStateRE();

  return (
    <Page title="statisticsLabels:tenantWasteTypes" fullHeight>
      <TenantWasteTypesCard realEstateId={currentTerminal.id} />
    </Page>
  );
};

export default TenantWasteTypes;
